import { render } from "./report-work-drivers.vue?vue&type=template&id=2ed5e3f2"
import script from "./report-work-drivers.vue?vue&type=script&lang=js"
export * from "./report-work-drivers.vue?vue&type=script&lang=js"

import "./report-work-drivers.vue?vue&type=style&index=0&id=2ed5e3f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__